__webpack_require__.p = "/partner-manage/";